import { render } from "./Order.vue?vue&type=template&id=32c4b4db&scoped=true"
import script from "./Order.vue?vue&type=script&lang=js"
export * from "./Order.vue?vue&type=script&lang=js"

import "./Order.vue?vue&type=style&index=0&id=32c4b4db&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32c4b4db"

export default script